import styles from './BulletResults.module.scss'

export const BulletResults = ({ mlResults, handleSendMessage }) => {
    return (
        <>
            {mlResults.clusters &&
                mlResults.clusters.map((cluster) => (
                    <div key={cluster.clusterName} className={styles.clusterContainer}>
                        <p className={styles.clusterName}>
                            {cluster.clusterName}&nbsp;(
                            {((100.0 * cluster.count) / mlResults.numInstances).toFixed(1)}
                            %)
                        </p>
                        <div className={styles.clusterDescription}>
                            {cluster.clusterDescription}
                            {cluster.rules && handleSendMessage && (
                                <>
                                    &nbsp;
                                    <a
                                        className={styles.exploreLink}
                                        onClick={(event) => {
                                            handleSendMessage({
                                                prompt:
                                                    'Visualize the dataset where the following rules apply: ' +
                                                    JSON.stringify(cluster.rules),
                                            })
                                        }}
                                    >
                                        Explore
                                    </a>
                                </>
                            )}
                        </div>
                    </div>
                ))}
            {mlResults.bullets &&
                mlResults.bullets.map((bullet, index) => (
                    <div key={index} className={styles.bulletContainer}>
                        {bullet.summary}
                        {bullet['sub-bullets'] && (
                            <ul className={styles.subBulletList}>
                                {bullet['sub-bullets'].map((subbullet) => (
                                    <li key={subbullet.text}>{subbullet.text}</li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
        </>
    )
}
